import * as log from "loglevel";
import * as React from "react";

import { inject, observer } from "mobx-react";
import { withRouter } from "react-router-dom";
import { Button, Form, Icon } from "semantic-ui-react";
import { AuthStore } from "../../../stores/auth-store";
import { AccountRequirements } from "../../../stores/models/user";

declare var toastr: any;

interface ITermsProps{
	authStore?: AuthStore;
	onNext?(): void;
}

interface ITermsState{
	termsAccepted: boolean;
	marketingOptIn: boolean;
	jumpNotification: boolean;
}

@inject("authStore") @observer
export class Terms extends React.Component<ITermsProps, ITermsState>{
	constructor(props, state){
		super(props, state);

		this.state = {"termsAccepted": false, "marketingOptIn" : false, "jumpNotification": true};
		this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
	}

	handleCheckboxChange(e: any, {name}){
		let value = !this.state[name];
		this.setState({[name]: value});
	}

	async handleSubmit(e: any){
		e.preventDefault();
		e.stopPropagation();

		if(await this.props.authStore.acceptTerms(this.state.termsAccepted)){
			if(await this.props.authStore.optIn(this.state.jumpNotification, this.state.marketingOptIn)){
				toastr.info("Setup Complete");
				if(this.props.onNext){
					this.props.onNext();
				}

			}
		}
	}
	render(){
		return(
			<div>
				{this.props.authStore.hasRequirement(AccountRequirements.ReAcceptTerms) &&
					<div>Our Terms and Conditions have changed. Please reaccept the new Terms and Conditions to continue on to the site.</div>
				}
				<iframe src="https://cdn.jibunu.com/forms/terms-of-use-5-23-18.pdf" style={{"width": "100%", "height": "500px"}} />
				<Form onSubmit={this.handleSubmit} style={{"textAlign": "left"}}>
					<Form.Field>
						<Form.Checkbox required label="Accept Terms and Conditions" name="termsAccepted" checked={this.state.termsAccepted} onChange={this.handleCheckboxChange} />
					</Form.Field>
					<Form.Field>
						<Form.Checkbox required label="I would like to receive an email when I have been given access to additional JUMP projects." name="jumpNotification" checked={this.state.jumpNotification} onChange={this.handleCheckboxChange} />
					</Form.Field>
					<Form.Field>
						{!this.props.authStore.hasRequirement(AccountRequirements.ReAcceptTerms) &&
							<Form.Checkbox label="I would like to receive occasional marketing emails which may include new technology updates and discount offers." name="marketingOptIn" checked={this.state.marketingOptIn} onChange={this.handleCheckboxChange} />
						}
					</Form.Field>
					<Button type="submit" icon className="jibunu-green" labelPosition="left" disabled={!this.state.termsAccepted}>
						<Icon name="arrow circle right" />
							Next
					</Button>
				</Form>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/views/auth/forms/terms.tsx